// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header.header-container {
  background: #000000;
  padding-bottom: 18px;
}
ion-header.header-container.has-kiosk-row {
  padding-bottom: 25px;
}
ion-header.header-container ion-toolbar {
  padding-right: 0;
  padding-bottom: 0;
  padding-left: 0;
  --background: #000000;
  --min-height: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
  --border-width: 0;
}
ion-header.header-container ion-toolbar .header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 43px;
  padding: 12px 20px 0;
}
ion-header.header-container ion-toolbar .header-content .back-arrow-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  cursor: pointer;
}
ion-header.header-container ion-toolbar .header-content .back-arrow-btn ion-icon {
  font-size: 22px;
  color: #ffffff;
}
ion-header.header-container .kiosk-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  height: 24px;
  margin-top: 25px;
  padding: 0 20px;
}
ion-header.header-container .kiosk-row .info-icon {
  width: 21px;
  height: 21px;
  margin-right: auto;
  cursor: pointer;
}
ion-header.header-container .kiosk-selector {
  display: flex;
  align-items: stretch;
  height: 24px;
}
ion-header.header-container .kiosk-selector .kiosk-number-display {
  display: flex;
  align-items: center;
  padding: 0 10px;
  border: 1px solid #383838;
  border-right: none;
  border-radius: 3px 0 0 3px;
}
ion-header.header-container .kiosk-selector .kiosk-number-display .kiosk-label {
  color: #c2c2c2;
  font-family: AppFontEintrachtOFCSans;
  font-size: 12px;
  line-height: 110%;
  white-space: nowrap;
}
ion-header.header-container .kiosk-selector .kiosk-number-display .kiosk-value {
  color: #ffffff;
}
ion-header.header-container .kiosk-selector .change-btn {
  width: 74px;
  padding: 0;
  background: var(--ion-color-eintracht-red);
  border: 1px solid var(--ion-color-eintracht-red);
  border-radius: 0 3px 3px 0;
  color: #ffffff;
  font-family: AppFontEintrachtOFCSans;
  font-size: 12px;
  line-height: 110%;
  cursor: pointer;
  transition: background-color 120ms ease-out;
}
ion-header.header-container .kiosk-selector .change-btn:active {
  background: #b1050f;
}

.kiosk {
  display: flex;
  width: max-content;
  margin: 0 10% 0 auto;
  height: 24px;
}
.kiosk div {
  padding: 6px 10px;
}
.kiosk div:first-child {
  color: var(--ion-color-white);
  border: 1px solid #383838;
  border-right: none;
  background: var(--ion-color-black);
}
.kiosk div:first-child span {
  color: #D2D2D2;
}
.kiosk div:last-child {
  padding: 6px;
  background: var(--ion-color-white);
  font-family: var(--ion-font-family);
  font-weight: 700;
}

.back-btn {
  --color: var(--ion-color-white);
  --border-width: 0;
  margin-top: 8px;
  margin-right: 20px;
}
.back-btn ion-icon {
  font-size: 22px;
}

.close-button-db {
  --border-style: none;
}

.no-r-margin {
  margin-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/main-header/main-header.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,oBAAA;AACF;AACE;EACE,oBAAA;AACJ;AAGE;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AADJ;AAGI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AADN;AAGM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AADR;AAGQ;EACE,eAAA;EACA,cAAA;AADV;AAOE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AALJ;AAOI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AALN;AASE;EACE,aAAA;EACA,oBAAA;EACA,YAAA;AAPJ;AASI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,0BAAA;AAPN;AASM;EACE,cAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAPR;AAUM;EACE,cAAA;AARR;AAYI;EACE,WAAA;EACA,UAAA;EACA,0CAAA;EACA,gDAAA;EACA,0BAAA;EACA,cAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,2CAAA;AAVN;AAYM;EACE,mBAAA;AAVR;;AAgBA;EACE,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;AAbF;AAcE;EACE,iBAAA;AAZJ;AAcE;EACE,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,kCAAA;AAZJ;AAaM;EACE,cAAA;AAXR;AAcE;EACE,YAAA;EACA,kCAAA;EACA,mCAAA;EACA,gBAAA;AAZJ;;AAiBA;EACE,+BAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAdF;AAgBE;EACE,eAAA;AAdJ;;AAkBA;EACE,oBAAA;AAfF;;AAiBA;EACE,eAAA;AAdF","sourcesContent":["ion-header.header-container {\n  background: #000000;\n  padding-bottom: 18px;\n\n  &.has-kiosk-row {\n    padding-bottom: 25px;\n  }\n\n  // global.scss forces padding-top: max(safe-area, 7px) on every toolbar\n  ion-toolbar {\n    padding-right: 0;\n    padding-bottom: 0;\n    padding-left: 0;\n    --background: #000000;\n    --min-height: 0;\n    --padding-top: 0;\n    --padding-bottom: 0;\n    --padding-start: 0;\n    --padding-end: 0;\n    --border-width: 0;\n\n    .header-content {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n      height: 43px;\n      padding: 12px 20px 0;\n\n      .back-arrow-btn {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 22px;\n        height: 22px;\n        flex-shrink: 0;\n        cursor: pointer;\n\n        ion-icon {\n          font-size: 22px;\n          color: #ffffff;\n        }\n      }\n    }\n  }\n\n  .kiosk-row {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 12px;\n    height: 24px;\n    margin-top: 25px;\n    padding: 0 20px;\n\n    .info-icon {\n      width: 21px;\n      height: 21px;\n      margin-right: auto;\n      cursor: pointer;\n    }\n  }\n\n  .kiosk-selector {\n    display: flex;\n    align-items: stretch;\n    height: 24px;\n\n    .kiosk-number-display {\n      display: flex;\n      align-items: center;\n      padding: 0 10px;\n      border: 1px solid #383838;\n      border-right: none;\n      border-radius: 3px 0 0 3px;\n\n      .kiosk-label {\n        color: #c2c2c2;\n        font-family: AppFontEintrachtOFCSans;\n        font-size: 12px;\n        line-height: 110%;\n        white-space: nowrap;\n      }\n\n      .kiosk-value {\n        color: #ffffff;\n      }\n    }\n\n    .change-btn {\n      width: 74px;\n      padding: 0;\n      background: var(--ion-color-eintracht-red);\n      border: 1px solid var(--ion-color-eintracht-red);\n      border-radius: 0 3px 3px 0;\n      color: #ffffff;\n      font-family: AppFontEintrachtOFCSans;\n      font-size: 12px;\n      line-height: 110%;\n      cursor: pointer;\n      transition: background-color 120ms ease-out;\n\n      &:active {\n        background: darken(#e30613, 10%);\n      }\n    }\n  }\n}\n\n.kiosk {\n  display: flex;\n  width: max-content;\n  margin: 0 10% 0 auto;\n  height: 24px;\n  div {\n    padding: 6px 10px;\n  }\n  div:first-child{\n    color: var(--ion-color-white);\n    border: 1px solid #383838;\n    border-right: none;\n    background: var(--ion-color-black);\n      span {\n        color: #D2D2D2;\n      }\n  }\n  div:last-child{\n    padding: 6px; \n    background: var(--ion-color-white);\n    font-family: var(--ion-font-family);\n    font-weight: 700;\n  }\n\n}\n\n.back-btn {\n  --color: var(--ion-color-white);\n  --border-width: 0;\n  margin-top: 8px;\n  margin-right: 20px;\n\n  ion-icon {\n    font-size: 22px;\n  }\n}\n\n.close-button-db {\n  --border-style: none;\n}\n.no-r-margin {\n  margin-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
